/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92939e84817951d5887a32dbe5eec4cf>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#26251e" d="M36.674 16.124 24.625 9.168a1.25 1.25 0 0 0-1.251 0l-12.05 6.956a1.05 1.05 0 0 0-.525.912v14.028c0 .376.2.723.526.91l12.05 6.958c.386.223.864.223 1.25 0l12.05-6.957c.325-.188.526-.535.526-.911V17.035c0-.376-.2-.723-.526-.91m-.757 1.474L24.286 37.745c-.079.136-.287.08-.287-.077V24.476a.74.74 0 0 0-.369-.64L12.206 17.24c-.136-.078-.08-.286.077-.286h23.264a.43.43 0 0 1 .371.644"/></svg>';

/**
 * __CursorIcon__
 *
 * A third-party logo icon for Cursor.
 */
export function CursorIcon({
	size,
	label = 'Cursor',
	testId,
	type,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper markup={markup} label={label} size={size} testId={testId} type={type} />
	);
}
